/* Amara: always use AJAX add-to-cart and the native cart drawer. */
window.MinimogSettings = window.MinimogSettings || {};
window.MinimogSettings.use_ajax_atc = true;
window.MinimogSettings.enable_cart_drawer = true;

class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector('.m-cart-drawer__inner');
    this.cartDrawerCloseIcon = this.querySelector('.m-cart-drawer__close');
    this.rootUrl = window.Shopify.routes.root;
    this.setHeaderCartIconAccessibility();
    this.cartDrawerCloseIcon?.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', (event) => {
      if (!event.target.closest('.m-cart-drawer__inner')) this.close();
    });
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('.m-cart-icon-bubble').forEach((trigger) => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(trigger);
      });
    });
  }

  open(trigger) {
    if (trigger) this.setActiveElement(trigger);
    this.classList.add('m-cart-drawer--active');
    requestAnimationFrame(() => {
      this.style.setProperty('--m-bg-opacity', '1');
      this.cartDrawerInner.style.setProperty('--translate-x', '0');
    });
    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
    document.documentElement.classList.add('prevent-scroll');
  }

  close() {
    this.style.setProperty('--m-bg-opacity', '0');
    this.cartDrawerInner.style.setProperty('--translate-x', '100%');
    setTimeout(() => {
      this.classList.remove('m-cart-drawer--active');
      document.documentElement.classList.remove('prevent-scroll');
      this.activeElement?.focus?.();
    }, 300);
  }

  showAddedConfirmation() {
    let notice = this.querySelector('[data-amara-added-notice]');

    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'amara-cart-added-notice';
      notice.setAttribute('data-amara-added-notice', '');
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.innerHTML = `
        <span class="amara-cart-added-notice__icon" aria-hidden="true">✓</span>
        <span>
          <strong>Added to your bag</strong>
          <small>Your cart has been updated.</small>
        </span>
      `;
      this.cartDrawerInner.appendChild(notice);
    }

    clearTimeout(this.addedNoticeTimer);
    notice.classList.remove('is-visible');
    void notice.offsetWidth;
    notice.classList.add('is-visible');
    this.cartDrawerInner.classList.remove('amara-cart-drawer__inner--confirmed');
    void this.cartDrawerInner.offsetWidth;
    this.cartDrawerInner.classList.add('amara-cart-drawer__inner--confirmed');

    this.addedNoticeTimer = setTimeout(() => {
      notice.classList.remove('is-visible');
      this.cartDrawerInner.classList.remove('amara-cart-drawer__inner--confirmed');
    }, 2200);
  }

  renderContents(response) {
    this.classList.remove('m-cart--empty');
    this.productId = response.id;
    this.getSectionsToRender().forEach((section) => {
      const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (target && response.sections?.[section.id]) {
        target.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
      }
    });
    setTimeout(() => {
      this.open();
      this.showAddedConfirmation();
      window.FoxKitV2?.Modules?.InCart?.getCart?.();
    });
  }

  updateCartCount(count) {
    document.querySelectorAll('.m-cart-count-bubble').forEach((bubble) => {
      if (count > 0) {
        bubble.textContent = count;
        bubble.classList.remove('hidden');
      } else {
        bubble.classList.add('hidden');
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + 'cart.json');
  }

  onCartDrawerUpdate(updateFooter = true) {
    fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((html) => {
        this.getSectionsToRender().forEach((section) => {
          if (!updateFooter && section.block === 'cart-footer') return;
          const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (target) target.innerHTML = this.getSectionInnerHTML(html, section.selector);
        });
        window.FoxKitV2?.Modules?.InCart?.getCart?.();
      })
      .catch(() => {});

    this.getCart().then((cart) => {
      this.classList.toggle('m-cart--empty', cart.item_count === 0);
      this.updateCartCount(cart.item_count);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '[data-amara-cart-top]', block: 'cart-footer' },
      { id: 'cart-drawer', selector: '[data-minimog-cart-items]', block: 'cart-items' },
      { id: 'cart-drawer', selector: '[data-amara-cart-footer]', block: 'cart-footer' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('m-cart-drawer', MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      { id: 'MinimogCartDrawer', section: 'cart-drawer', selector: '[data-amara-cart-top]' },
      { id: 'MinimogCartDrawer', section: 'cart-drawer', selector: '[data-minimog-cart-items]' },
      { id: 'MinimogCartDrawer', section: 'cart-drawer', selector: '[data-amara-cart-footer]' }
    ];
  }
}

customElements.define('m-cart-drawer-items', MCartDrawerItems);
